import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Qog'oz Atelier",
    description: "Handmade Samarkand silk paper from mulberry bark, made near Samarkand the way it was made a thousand years ago. Sheets, notebooks and wedding stationery shipped worldwide, and half-day papermaking workshops.",
    placeholder: '',
    url: getOrigin(),
    ogImage: 'https://lively-eagle-vf7.cdn.modulify.website/images/share/qogoz-atelier-share.jpg'
}

export const NAV_LINKS: Array<NavLink> = [
    { label: 'Shop', href: '/shop' },
    { label: 'Workshops', href: '/workshops' },
    { label: 'The craft', href: '/craft' },
    { label: 'Contact', href: '/contact' }
]

export const ATELIER = {
    region: 'Samarkand region, Uzbekistan',
    place: 'On a mulberry-lined stream, 14 km from the Registan',
    hours: 'Tuesday to Sunday, 9:00 to 18:00',
    timezone: 'Samarkand time, UTC+5',
    languages: 'English, Russian, Uzbek and Tajik',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Samarkand%2C%20Uzbekistan',
    year: '2026'
}
